import { Pipe, PipeTransform } from '@angular/core';
import { StatisticsExtractor } from 'app/trello/utility/statistics-extractor';

@Pipe({
  name: 'deltaSymbol',
  pure: true,
})
export class DeltaSymbolPipe implements PipeTransform {

  constructor(
    private readonly statisticsExtractor: StatisticsExtractor,
  ) {
  }

  transform(
    values1: any[] | undefined,
    values2: any[] | undefined,
  ): string {
    return this.statisticsExtractor.deltaSymbol(values1, values2);
  }

}
